// extracted by mini-css-extract-plugin
export default {"backdrop":"upload_backdrop__4hHcU","driftA":"upload_driftA__gvHNl","driftB":"upload_driftB__u4ybf","grain":"upload_grain__r2FZw"};